(function () {
  const STORAGE_KEY = 'league_actions_grid_visible';

  const leagueActionsGridApp = function () {
    const getStoredState = () => {
      return localStorage.getItem(STORAGE_KEY) === 'true';
    };

    const setStoredState = (value) => {
      if (value) {
        localStorage.setItem(STORAGE_KEY, 'true');
      } else {
        localStorage.removeItem(STORAGE_KEY);
      }
    };

    const bindLeagueActionsToggle = () => {
      const toggle = $('#league-actions-toggle');
      const grid = $('.league-actions-grid');

      if (toggle.length && grid.length) {
        const storedState = getStoredState();
        if (storedState) {
          toggle.prop('checked', true);
          grid.removeClass('d-none');
        }

        toggle.on('change', function () {
          const isChecked = $(this).is(':checked');

          if (isChecked) {
            grid.removeClass('d-none');
            setStoredState(true);
          } else {
            grid.addClass('d-none');
            setStoredState(false);
            grid.find('.league-action-submenu').addClass('d-none');
            $('.league-actions-main-menu').removeClass('d-none');
          }
        });
      }
    };

    const bindLeagueActionCards = () => {
      const $mainMenu = $('.league-actions-main-menu');

      $(document).on('click', '.league-action-card[data-action]', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const action = $(this).data('action');
        const $submenu = $(`.league-action-submenu[data-submenu="${action}"]`);

        if ($submenu.length) {
          $mainMenu.addClass('d-none');
          $submenu.removeClass('d-none');
        }
      });

      $(document).on('click', '.league-action-card[data-submenu]', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const submenuName = $(this).data('submenu');
        const $currentSubmenu = $(this).closest('.league-action-submenu');

        const $targetSubmenu = $('.league-actions-grid').find(`.league-action-submenu[data-submenu="${submenuName}"]`);

        if ($targetSubmenu.length) {
          $currentSubmenu.addClass('d-none');
          $targetSubmenu.removeClass('d-none');
        } else {
          console.warn(`Submenu "${submenuName}" não encontrado`);
        }
      });

      const handleBack = function (e) {
        e.preventDefault();
        e.stopPropagation();

        const backTo = $(this).data('back-to');
        const $currentSubmenu = $(this).closest('.league-action-submenu');

        if (backTo) {
          const $targetSubmenu = $('.league-actions-grid').find(`.league-action-submenu[data-submenu="${backTo}"]`);
          $currentSubmenu.addClass('d-none');
          $targetSubmenu.removeClass('d-none');
        } else {
          $currentSubmenu.addClass('d-none');
          $mainMenu.removeClass('d-none');
        }
      };

      $(document).on('click', '.league-actions-back', handleBack);

      $(document).on('click', '.league-actions-back-icon', handleBack);
    };

    const init = () => {
      bindLeagueActionsToggle();
      bindLeagueActionCards();
    };

    $(document).on('turbolinks:load', init);
  };

  if (typeof window !== 'undefined') {
    window.leagueActionsGridApp = leagueActionsGridApp();
  }

  return leagueActionsGridApp;
})();

